export default __webpack_public_path__ + "assets/instagram-header-background.e62209aa.png";